import React, { useContext, useEffect, useState } from 'react'
import { SearchContext } from '../../lib/context/search-context'
import HeaderSearchBar from '../widgets/header-search-bar'
import moment from 'moment'
import config from '../../config'
import Search from './search'
import Loading from '../loading'
import { useTranslation } from 'next-i18next'
import { buildSearchParams } from '../../lib/helpers'
import { useRouter } from 'next/router'
import axios from 'axios'

const Stays = ({ filterTypes, headerFilterTypes, filterAreas, filterTabs }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { searchParams, setSearchParameters } = useContext(SearchContext)
  const [newSearch, setNewSearch] = useState(false)
  const { i18n } = useTranslation('common')
  const router = useRouter()
  useEffect(() => {
    if (data.length == 0 && loading) {
      axios({
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_API_URL}/hotels`,
        params: {
          locale: i18n.language,
        },
      }).then((r) => {
        setData(r.data)
        setLoading(false)
      })
    }
    // console.log('SP', searchParams)
    const queryParams = buildSearchParams(router, searchParams)
    // console.log('QP', queryParams)
    setSearchParameters(queryParams, 0, config.cookieOptions)
  }, [data, loading])
  const reloadDates = (params) => {
    setNewSearch(false)
    setSearchParameters(params, 0, config.cookieOptions)
  }

  // console.log(searchParams)
  return (
    <>
      <HeaderSearchBar
        guests={searchParams.guests}
        checkInDate={
          searchParams.checkinDate ? moment(searchParams.checkinDate) : null
        }
        checkOutDate={
          searchParams.checkoutDate ? moment(searchParams.checkoutDate) : null
        }
        onUpdate={reloadDates}
        showEdit={newSearch}
        onSearch={() => {
          setNewSearch(true)
        }}
        filterTypes={headerFilterTypes}
      />
      {loading && <Loading />}
      {!loading && (
        <Search
          newSearch={!newSearch}
          hotels={data}
          filterTypes={filterTypes}
          filterAreas={filterAreas}
          filterTabs={filterTabs}
        />
      )}
    </>
  )
}
export default Stays
